
const NoItems = ({purchasesServices, purchasesProducts}) => {
    return (
        !purchasesServices.length && !purchasesProducts.length &&
        <div style={{width: "100%"}} className="d-flex just-content-center">
            <div className="no-payments">
                <h3>
                    Ваш кошик на даний момент порожній <span>🤔</span>
                </h3>
                <p>
                    Виправити це можна на головній сторінці
                </p>
            </div>
        </div>
    );
};

export default NoItems;